export default __webpack_public_path__ + "static/media/RecombineHome.be71c738.png";